
export default function ServiceArea() {
  const areas = [
    {
      city: '岡山市',
      districts: ['北区', '中区', '東区', '南区'],
      description: '岡山市全域で対応しております。市内中心部から郊外まで、迅速にお伺いいたします。',
      image: 'https://public.readdy.ai/ai/img_res/da4ace32d79b388a5bcfcea9d75681ed.jpg'
    },
    {
      city: '倉敷市',
      districts: ['倉敷', '児島', '玉島', '水島', '真備'],
      description: '倉敷市全域をカバー。歴史ある街並みから新興住宅地まで、地域特性を活かした工事を行います。',
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20residential%20area%20in%20Kurashiki%20with%20mix%20of%20modern%20and%20traditional%20houses%2C%20clean%20neighborhood%20streets%2C%20well-maintained%20properties%2C%20peaceful%20suburban%20environment%2C%20natural%20lighting&width=400&height=300&seq=kurashiki&orientation=landscape'
    },
    {
      city: 'その他岡山県内',
      districts: ['総社市', '玉野市', '津山市', '笠岡市', '井原市', '赤磐市'],
      description: '岡山県内全域に対応可能です。エリアによっては出張費をいただく場合がございます。',
      image: 'https://readdy.ai/api/search-image?query=Scenic%20view%20of%20Okayama%20prefecture%20countryside%20with%20modern%20Japanese%20residential%20houses%2C%20rural%20landscape%2C%20mountains%20in%20background%2C%20peaceful%20community%2C%20well-maintained%20homes%2C%20natural%20environment&width=400&height=300&seq=okayama-other&orientation=landscape'
    }
  ];

  return (
    <section className="py-12 sm:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">
            <strong>対応エリア</strong>
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            岡山市・倉敷市を中心に、岡山県内全域でリフォーム工事を承っております
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mb-8 sm:mb-12">
          {areas.map((area, index) => (
            <div key={index} className="bg-gray-50 rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <div className="h-40 sm:h-48 overflow-hidden">
                <img
                  src={area.image}
                  alt={area.city}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-5 sm:p-6">
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3 sm:mb-4">{area.city}</h3>
                <div className="mb-3 sm:mb-4">
                  <div className="flex flex-wrap gap-1.5 sm:gap-2">
                    {area.districts.map((district, idx) => (
                      <span key={idx} className="bg-teal-100 text-teal-800 text-xs font-medium px-2 py-0.5 sm:py-1 rounded">
                        {district}
                      </span>
                    ))}
                  </div>
                </div>
                <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">{area.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-lg p-6 sm:p-8">
          <div className="text-center">
            <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3 sm:mb-4">
              <strong>地域密着25年の実績</strong>
            </h3>
            <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 max-w-3xl mx-auto px-4">
              2000年の創業以来、岡山県内で数多くのリフォーム工事を手がけてまいりました。地域の気候や建物の特性を熟知した経験豊富なスタッフが、お客様のご要望にお応えいたします。
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 max-w-4xl mx-auto">
              <div className="text-center">
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-3">
                  <i className="ri-time-line text-xl sm:text-2xl text-teal-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-1.5 sm:mb-2 text-sm sm:text-base">迅速対応</h4>
                <p className="text-gray-600 text-xs sm:text-sm px-2">お問い合わせから現地調査まで、スピーディーに対応いたします</p>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-3">
                  <i className="ri-map-pin-2-line text-xl sm:text-2xl text-teal-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-1.5 sm:mb-2 text-sm sm:text-base">地域密着</h4>
                <p className="text-gray-600 text-xs sm:text-sm px-2">地域の特性を活かした最適なリフォームプランをご提案</p>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-3">
                  <i className="ri-customer-service-2-line text-xl sm:text-2xl text-teal-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-1.5 sm:mb-2 text-sm sm:text-base">アフターサポート</h4>
                <p className="text-gray-600 text-xs sm:text-sm px-2">工事完了後も継続的なメンテナンスでサポート</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
